import useEntityAdapter, { OperationSpecs } from 'src/hooks/useEntityAdapter';
import { GET_ALL_OPP_CLOSE_REASON } from '../graphql/queries';
import {
  UPDATE_OPP_CLOSE_REASON,
  CREATE_OPP_CLOSE_REASON,
  REMOVE_OPP_CLOSE_REASON,
} from '../graphql/mutations';
import { CloseReasonModel } from '../models/closeReason.model';
import { closeReasonAdapter } from '../adapters/closeReason.adapter';

const operations: OperationSpecs = {
  createOne: {
    op: CREATE_OPP_CLOSE_REASON,
  },
  updateOne: {
    op: UPDATE_OPP_CLOSE_REASON,
  },
  deleteOne: {
    op: REMOVE_OPP_CLOSE_REASON,
  },
  fetchAll: {
    op: GET_ALL_OPP_CLOSE_REASON,
    dataPath: 'GetAllOpportunityCloseReasons',
  },
};

const useOpportunityCloseReasonsStore = () => {
  const api = useEntityAdapter<CloseReasonModel>({
    adapters: { entityAdapter: closeReasonAdapter },
    operations,
    isPaginated: true,
    entityName: 'OpportunityCloseReasons',
  });

  return api;
};

export default useOpportunityCloseReasonsStore;
